import { fetchGlobalAlerts, TIME_MS, useGlobalAlertsState } from '@core-systems/frontend-shared';
import { getEnvironment } from '@env';
import { useQuery } from '@tanstack/react-query';

export const GLOBAL_ALERTS_QUERY_KEY = ['globalAlerts'] as const;

export const useGlobalAlerts = () => {
  const assetUrl = getEnvironment()?.assetUrls?.globalAlertsRemote ?? '';

  const { data: alerts = [] } = useQuery({
    queryKey: [GLOBAL_ALERTS_QUERY_KEY[0], assetUrl] as const,
    queryFn: ({ signal }) => fetchGlobalAlerts(assetUrl, signal, import.meta.env.VITE_ENV_NAME),
    staleTime: TIME_MS.MINUTE
  });

  return useGlobalAlertsState(alerts);
};
